import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AmpButton from "../../common/AmpButton/AmpButton";
import { DefaultRegTabProps } from "../RegistrationTypes";



export default function AddressConfirm(props: DefaultRegTabProps) {

    const { t } = useTranslation('login');

    const storedAddress = localStorage.getItem("addressCheck");

    return (
    <>
        <div className="dark-blue-background"></div>
        <div className="login-container-mid">
            <p>{t("0-p-1")}</p>
        </div>
        <div className="login-container-mid">
            <h3>{storedAddress}</h3>
        </div>
        <div className="login-container-mid">
            <Trans defaults={t("0-p-3")}>
                <Link target="_blank" className="amp-anchor blue" to="/auth/contact-us" rel="noreferrer noopener"></Link>
            </Trans>
            <p>{t("0-p-2")}</p>
        </div>
        <div className="login-container-footer">
            <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
            <div>
                <AmpButton type="cancel" onClick={() => props.triggerCancel(true)} text={t("cancel")} />
                <AmpButton type="submit" onClick={() => props.setActiveTab(1)} text={t("agree")} />
            </div>
        </div>
    </>)
}